import React, { useState, useEffect, useRef, memo } from "react";

import "./ClockChat.scss";
import { convertSlaTime } from "../../../../../../Libs/CustomMethods/customMethods";
import { UncontrolledTooltip } from "reactstrap";

const Clock = (props) => {
  const [timer, setTimer] = useState(0);
  const interval = useRef(null);
  const [timeF, setTimeF] = useState({
    full: "",
    summary: "",
  });

  const handleTimer = (assignedTime, reset, endTime) => {
    setTimer((prev) => {
      return endTime
        ? Math.abs(
            (new Date(endTime).getTime() - new Date(assignedTime).getTime()) /
              1000
          )
        : reset
        ? Math.abs((Date.now() - new Date(assignedTime).getTime()) / 1000)
        : prev + 1;
    });
  };

  useEffect(() => {
    setTimeF(convertSlaTime(timer, { withSummary: true }));
  }, [timer]);

  useEffect(() => {
    if (props?.chatId && props?.assignedTime) {
      if (interval?.current) clearInterval(interval.current);

      if (!props?.endTime) {
        handleTimer(props.assignedTime, true);
        interval.current = setInterval(
          () => handleTimer(props.assignedTime),
          1000
        );
      } else {
        handleTimer(props.assignedTime, false, props.endTime);
      }
    }
    return () => clearInterval(interval?.current);
  }, [props?.chatId, props?.assignedTime, props?.status]);

  return (
    <>
      <div>
        <div id="tooltip-aassigned-time" className="time-ticket"> {props?.queueSize ?? timeF.summary}</div>
        <UncontrolledTooltip
            className="tooltip-actions"
            placement="auto"
            target={`tooltip-aassigned-time`}
          >
            {`${timeF?.full}`}
          </UncontrolledTooltip>
      </div>
    </>
  );
};

export default memo(Clock);
